import React, { ReactNode } from 'react'
import Layout from 'antd/lib/layout'
import Header from '@components/Layouts/Header'
import EventDetailsFooter from '@components/Event/DetailsFooter'

import styles from './index.scss'

interface IEventDetailsLayout {
    title: string
    children: ReactNode
    widthPage: string
}

function EventDetailsLayout(props: IEventDetailsLayout) {
    const { children, title, widthPage } = props
    return (
        <Layout className={styles['event-details-layout']}>
            {/* {width <= BREAKPOINTS.MD && <Sider layoutMode="event-details" />}
            <Layout> */}
            <Header layoutMode="event-details" />
            <Layout.Content className={styles['event-details-layout__content']} style={{ maxWidth: widthPage }}>
                <h1 className={styles['event-details-layout__content_title']}>{title}</h1>
                {children}
            </Layout.Content>
            <EventDetailsFooter />
            {/* </Layout> */}
        </Layout>
    )
}

export default EventDetailsLayout
